import { Controller } from "@hotwired/stimulus"

// Guest Form Controller
// Handles guest form submissions and interactions
export default class extends Controller {
  connect() {
  }

  handleSubmit(event) {
    // This method is called after Turbo handles the form submission
    // We can use it to handle any post-submission logic if needed
    const response = event.detail.fetchResponse
    
    if (response.succeeded) {
      // Form submitted successfully
      this.resetForm()
    }
  }

  resetForm() {
    // Reset form if it's the quick add form
    if (this.element.closest("#new-guest-form")) {
      this.element.reset()
      
      // Also hide plus one field if it was visible
      const plusOneToggle = this.element.querySelector('[data-plus_one_toggle-target="checkbox"]')
      const nameField = this.element.querySelector('[data-plus_one_toggle-target="nameField"]')
      
      if (plusOneToggle && nameField) {
        plusOneToggle.checked = false
        nameField.classList.add("hidden")
        // Clear the plus one name field
        const nameInput = nameField.querySelector('input')
        if (nameInput) {
          nameInput.value = ""
        }
      }
    }
  }

  // Handle form validation feedback
  showError(message) {
    // You could implement client-side error display here if needed
    console.log("Form error:", message)
  }

  showSuccess(message) {
    // You could implement client-side success feedback here if needed
    console.log("Form success:", message)
  }
}